module.exports = __webpack_public_path__ + "static/menu-bottom-697de3d4d7d387ed80adab39808aad47.svg";